export function PageHeader({ eyebrow, title, subtitle }: { eyebrow: string; title: string; subtitle?: string }) {
  return (
    <section className="relative bg-[#030303] text-white pt-16 pb-16 sm:pt-24 sm:pb-24 lg:pt-32 lg:pb-32 border-b border-white/5 overflow-hidden">
      <div className="absolute top-0 right-0 w-[36rem] h-[24rem] bg-amber-500/15 blur-[140px] pointer-events-none" />
      <div className="absolute -bottom-20 -left-20 w-[28rem] h-[20rem] bg-yellow-500/10 blur-[120px] pointer-events-none" />
      <div className="max-w-5xl mx-auto px-5 sm:px-6 relative">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 text-[10px] sm:text-[11px] font-medium tracking-widest uppercase text-amber-200 mb-5 sm:mb-7">
          {eyebrow}
        </div>
        <h1 className="font-serif text-[2.25rem] sm:text-5xl lg:text-7xl leading-[1.05] text-balance mb-5 sm:mb-6 bg-clip-text text-transparent bg-gradient-to-b from-white via-white to-white/50">{title}</h1>
        {subtitle && <p className="text-base sm:text-lg lg:text-xl text-zinc-400 font-light max-w-2xl text-pretty">{subtitle}</p>}
      </div>
    </section>
  );
}
